import * as React from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import { useCreationState } from "../creationFlowHooks";

import Layout from "../shared/Layout";
import Hero from "../shared/Hero";
import Button from "../shared/Button";
import TimeInput from "../shared/TimeInput";
import { useSubmitEntry } from "../poster/posterHooks";
import { basepath, eventDetails } from "../common/common";

const YourTime: React.FC = () => {
  const { error, user } = useCreationState();
  const history = useHistory();
  const { loading, submitEntry, submitted } = useSubmitEntry();
  const [digits, setDigits] = useState("");
  const [pageError, setPageError] = useState(undefined);
  const [validationError, setValidationError] = useState<string | undefined>(undefined);
  
  React.useEffect(() => {
    if (!user) {
      window.location.href = `${window.location.origin}/${basepath}`;
      return;
    }   
  }, [user]);
  
  React.useEffect(() => {
    if (error) {
      history.replace("/");
      toast.error(error);
    }
    if (pageError) {
      toast.error(pageError.message);
      const timer = setTimeout(() => {
        history.replace("/");
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [error, history, pageError]);

  const onSubmitEntry = () => {
    const rawDigits = digits.replace(/\D/g, "");
    if (rawDigits.length < 4) {
      setValidationError("Time must include 2 decimal places e.g. 09.34 or 59.02");
      return;
    }
    setValidationError(undefined);
    const raw = rawDigits.padStart(4, "0");
    const entryValue = Number(`${raw.slice(0, 2)}.${raw.slice(2, 4)}`);
    if (Number.isNaN(entryValue)) {
      setPageError({message: "Whoops! Something went wrong here, please try again."});
      return;
    }
    var event = eventDetails(basepath);
    if (event) {
      submitEntry({
        eventId: event.eventId,
        questionId: event.questionId,
        userId: user.id,
        value: entryValue
      });
    } else {
      setPageError({message: "Whoops! Something went wrong here, please try again."});
    }
  }

  React.useEffect(() => {
    if (submitted) {
      history.replace("/success");
    }
  }, [submitted]);

  return (
    <Layout>
      <Hero role="ENTERSPEED" />
      <div className="flex flex-col flex-1 items-center mx-5 overflow-hidden h-full">
        <div className="mt-7">
          <h1 className="text-font text-2xl text-center">
            What was your time?
          </h1>
          <p className="text-font text-smallLabel text-center">
            Enter players time below in seconds
          </p>
        </div>
        <div className="flex flex-col flex-grow pb-4 mt-4 w-full overflow-y-auto">
          <div className="place-items-center flex flex-col px-5 pt-7 pb-7 mb-2">
            <TimeInput
              value={digits}
              onChange={(v) => { setValidationError(undefined); setDigits(v); }}
              error={validationError}
            />
          </div>
          <div className="flex items-end justify-center py-2">
            <div className="flex">
            <Button
              theme="primary"
              className="self-end"
              onClick={onSubmitEntry}
              isLoading={loading}
            >
              Next
            </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default YourTime;
